import { useState, useEffect } from "react";
import { getContentGuideFor } from './inappImage';
import { useAppStore } from "../../store/models/app";
import useUIStates from '../../store/models/uistates/useUIStates';

function useInAppGuide () {

    const {
        selectedCalendar,
    } = useUIStates();
    const appStore = useAppStore();

    const computeContent = () => {
        const flags = appStore.flags;
        let os = null;
        if (flags?.ios) os = 'ios';
        else if (flags?.android) os = 'android';
        const appName = appStore.appName || appStore.getAppName();
        return getContentGuideFor(os, selectedCalendar, { app: appName });
    };

    const [guideContent, setGuideContent] = useState(computeContent);

    useEffect(() => {
        setGuideContent(computeContent());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCalendar, appStore.observed.userAgent]);

    return {
        ...guideContent,
    };
}

export default useInAppGuide;
